
import { loginUserReducer } from './auth/loginUser'
import { registerUserReducer } from './auth/registerUser'
import { conversionRateReducer } from './dashboard/conversionRate'
import { expectedRevenueReducer } from './dashboard/expectedRevenue'
import { noOfAttemptMissionReducer } from './dashboard/noOfAttemptMissions'
import { userPublisherDataReducer } from './dashboard/userPublisherData'
import { noOfDisqualifiedAttemptsReducer } from './dashboard/noOfDisqualifiedAttempts'
import { noOfDropAttemptsReducer } from './dashboard/noOfDropAttempts'
import { noOfExpectedImpressionsGeneratedReducer } from './dashboard/noOfExpectedImpressionsGenerated'
import { noOfQualifiedAttemptsReducer } from './dashboard/noOfQualifiedAttempts'
import { noOfParticipantAttemptsReducer } from './dashboard/noOfParticipantAttempts'
import { noOfQuitAttemptsReducer } from './dashboard/noOfQuitAttempts'

import {publisherPayoutReducer} from './dashboard/publisherPayout'



import { myProfileReducer } from './profile/my-profile'
// import { setPostbackReducer } from './postback/postbackLog'

import { appListReducer } from './apps/list'
import { appStoreReducer } from './apps/store'
import { appEditReducer } from './apps/edit'
import { appDetailReducer } from './apps/detail'
import { appRemoveRestoreReducer } from './apps/remove-restore'
import { appActivateReducer } from './apps/active'

import { uplodImageReducer } from './image/uploadImage'
import { appCategoryReducer } from './apps/categories'


import { addPaymentRequestReducer } from './payments/add-payment-request'
import { paymentRequestDetailsReducer } from './payments/payment-request-details'
import { paymentRequestListReducer } from './payments/payment-request-lists'

import { addBankReducer } from './accountDetail.jsx/addbank'
import { editBankReducer } from './accountDetail.jsx/editbank'
import { singleBankReducer } from './accountDetail.jsx/singlebank'
import { bankDeleteReducer } from './accountDetail.jsx/deletebank'
import { bankListReducer } from './accountDetail.jsx/banklist'

import { liveMissionListReducer } from './liveMission/list'
import { upcomingMissionListReducer } from './upcomingMission/list'
import { pausedMissionListReducer } from './pausedMission/list'
import { pastMissionListReducer } from './pastMission/list'
import { userListReducer } from './users/list'
import { knowledgeListReducer } from './knowledge/list'
import { postBackLogReducer } from './postback/postbackLog'
import { dashboardAttemptsReducer } from './dashboard/dashboard'
import { editProfileReducer } from './profile/edit'
import { noOfParticipantsin30DaysReducer } from './dashboard/participantsin30days'
import { forgetPasswordReducer } from './auth/forgetpassword'
import { checkOtpReducer } from './auth/checkotp'
import { resetPasswordReducer } from './auth/resetPassword'
import { rewardLastWeekReducer } from './dashboard/rewardLastWeek'
import { totalSurveyAttemptPublisherReducer } from './dashboard/totalSurveyAttempt'
import { testPostbackReducer } from './postback/testPostback'
import { userPayoutReducer } from './dashboard/userPayout'
import { dailyStatsReducer } from './stats/dailyStats'
import { appStatsReducer } from './stats/appStats'

import { userSurveryAttemptReducer } from './users/userSurveyAttempt'
import { dailyRevenueGraphReducer } from './dashboard/dailyRevenueGraph'
import { dailyActiveUserGraphReducer } from './dashboard/dailyActiveUserGraph'
import { singleUserTransactionReducer } from './users/singleUserTransaction'

import { sendOtpToDeleteAppReducer } from './apps/sendOtpToDeleteApp'

import { monthWiseEarningReducer } from './payments/month-wise-earning'

import { charegBackReducer } from './charegBack/chargeback'

import { userDetailsReducer } from './users/details'
import { monthWiseChargebackReducer } from './payments/month-wise-chargeback'
import { clearPostBackReducer } from './postback/clearPostBack'



export const toolkitReducers = {


    //charegback
    chargeBackData:charegBackReducer,


    loginUser: loginUserReducer,
    registerUser: registerUserReducer,
    checkotp:checkOtpReducer,
    forgetpassword:forgetPasswordReducer,
    resetpassword:resetPasswordReducer,
   
    // dashboard reducers
    dashboard: dashboardAttemptsReducer,
    conversionRate: conversionRateReducer,
    expectedRevenue: expectedRevenueReducer,
    attemptMission: noOfAttemptMissionReducer,
    userPublisherData:userPublisherDataReducer,
    disqualifiedAttempts: noOfDisqualifiedAttemptsReducer,
    dropAttempts: noOfDropAttemptsReducer,
    expectedImpressions: noOfExpectedImpressionsGeneratedReducer,
    qualifiedAttempts: noOfQualifiedAttemptsReducer,
    participantAttempts: noOfParticipantAttemptsReducer,
    quitAttempts: noOfQuitAttemptsReducer,
    totalSurveyAttempt:totalSurveyAttemptPublisherReducer,
    publisherPayout:publisherPayoutReducer,
    userPayout:userPayoutReducer,
    dailyRevenueGraph:dailyRevenueGraphReducer,
    dailyActiveUser:dailyActiveUserGraphReducer,

    //profile
    editProfile:editProfileReducer,
    myProfile: myProfileReducer,
    // setPostback: setPostbackReducer,s
    //app
    appLists: appListReducer,
    appStore: appStoreReducer,
    appEdit: appEditReducer,
    appDetail: appDetailReducer,
    appRemoveRestore: appRemoveRestoreReducer,
    appCategory:appCategoryReducer,
    appActivate:appActivateReducer,
    optToDeleteApp:sendOtpToDeleteAppReducer,
    

    //image upload

    getImage:uplodImageReducer,

    // bank detail

    addBank:addBankReducer,
    editBank:editBankReducer,
    singleBank:singleBankReducer,
    listBank:bankListReducer,
    deleteBank:bankDeleteReducer,

    // live mission

    liveMissionList:liveMissionListReducer,

    //past mission

    pastMissionList:pastMissionListReducer,

    //upcoming mission

    upcomingMissionList:upcomingMissionListReducer,

    //paused mission

    pausedMissionList:pausedMissionListReducer,

    //user

    userList:userListReducer,
    userSurverAttempt:userSurveryAttemptReducer,
    singleUserTransaction:singleUserTransactionReducer,
    singleUserData:userDetailsReducer,


    //payment

    addPayment:addPaymentRequestReducer,
    paymentList:paymentRequestListReducer,
    paymetnDetail:paymentRequestDetailsReducer,
    monthWiseEarning:monthWiseEarningReducer,
    monthWiseChargeback:monthWiseChargebackReducer,

    //knowledge

    knowledgeList:knowledgeListReducer,

    //postback log

    postbackLog:postBackLogReducer,
    testPostback:testPostbackReducer,
    clearPostback:clearPostBackReducer,

    //noOfParticipantsin30DaysReducer
    noOfParticipantsin30Days:noOfParticipantsin30DaysReducer,

    //totalNumberofRewardLastWeek
    totalRewardLastWeek:rewardLastWeekReducer,

    // stats
    dailyStats:dailyStatsReducer,
    appStats:appStatsReducer

    
}